/* eslint-disable max-statements */
/* eslint-disable camelcase */
/* eslint-disable max-lines-per-function */
/* eslint-disable no-alert */
import { useMutation, useQuery } from "@apollo/client";
import { navigate, RouteComponentProps } from "@reach/router";
import { gql } from "graphql-tag";
import { get, omit } from "lodash";
import moment from "moment";
import React, { useState, useEffect } from "react";
import { KeyboardDatePicker, KeyboardTimePicker } from "@material-ui/pickers";
import { Grid, FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import { Column, FormRow } from "components/common/html";
import { Button, DropDownButton } from "components/haven-design/buttons";
import logger from "services/logger";
import { parseDumbInterestForm } from "utils/interest";
import { getInterestListName, FormData, createInterest as createInterestType, createInterestVariables, InterestInput } from "types/gql-types";
import NewForm from "../interests-form";

type KeyOfInterestInput = keyof InterestInput;
type UnderscoredInterestInput = Record<string, InterestInput[KeyOfInterestInput]>;

const styles = {
  container: {
    padding: 20,
  },
  sidebarContainer: {
    minHeight: 450,
  },

  header: {
    marginTop: 0,
    textAlign: "left",
  },

  topPadding: {
    paddingTop: 16,
  },

  tableContainer: {
    minHeight: 450,
  },
  subheader: {
    boxShadow: `0 0 0 1px rgba(63,63,68,0.02),
                0 1px 3px rgba(63, 63, 68, 0.1),
                0 1px 2px rgba(0,0,0,0.02)`,
    backgroundColor: "white",
    minHeight: 58,
  },
} as const;

const QUERY_FORM_DATA = gql`
  query formData($interestListId: ID!) {
    applicationFormMetadata(interestListId: $interestListId, source: APP) {
      schema {
        name
        label
        options {
          label
          value
        }
      }
    }
  }
`;

const CREATE_NEW_INTEREST = gql`
  mutation createInterest($listId: String!, $data: InterestInput!) {
    createInterest(listId: $listId, data: $data) {
      id
      manuallyEntered
    }
  }
`;

const INTEREST_LIST_QUERY = gql`
  query getInterestListName($interestListId: ID!) {
    interestList(id: $interestListId) {
      id
      name
    }
  }
`;

const NewInterest: React.FC<RouteComponentProps & {listId?: string}> = (props) => {
  const [isFormReady, setIsFormReady] = useState(false);
  const [householdCount, setHouseholdCount] = useState(0);
  const newDateTime = moment();
  const [date, setDate] = useState(newDateTime);
  const [dateTime, setDateTime] = useState(newDateTime);
  const [time, setTime] = useState(newDateTime);
  const [submitBtnIndex, setSubmitBtnIndex] = useState(0);

  useEffect(() => {
    const currentDate = date.clone();
    currentDate.set({
      hour: time.get("hour"),
      minute: time.get("minute"),
      second: 0,
      millisecond: 0,
    });
    setDateTime(currentDate);
  }, [date, time]);

  const { listId: interestListId } = props;
  if (!interestListId) return null;
  const query = useQuery<FormData>(QUERY_FORM_DATA, { variables: { interestListId } });
  const interestListQuery =
    useQuery<getInterestListName>(INTEREST_LIST_QUERY, { variables: { interestListId } });

  const [createInterest, mutation] =
    useMutation<createInterestType, createInterestVariables>(CREATE_NEW_INTEREST);
  const onResetState = () => {
    setIsFormReady(() => false);
    setHouseholdCount(() => 0);
    setDate(() => newDateTime);
    setTime(() => newDateTime);
  };

  const isToday = (dateValue:moment.Moment) => dateValue.isSame(newDateTime, "day") &&
    dateValue.isSame(newDateTime, "month") &&
    dateValue.isSame(newDateTime, "year");
  const timeError = isToday(date) && moment().isBefore(time);
  const handleSelect = (event: React.ChangeEvent<{ value: unknown }>) =>
    setHouseholdCount(Number(event.target.value));
  const handleCancel = () => history.back();
  const handleDateChange = (currentMoment: string | moment.Moment | null | Date) => {
    const DateToSet = moment(currentMoment);

    setDate(DateToSet);

    if (isToday(DateToSet) && moment().isBefore(time)) {
      setTime(moment());
    }
  };
  const handleTimeChange = (currentMoment: string | moment.Moment | null | Date) =>
    setTime(moment(currentMoment));
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    let data = parseDumbInterestForm(event.target) as UnderscoredInterestInput;
    data.submitted_at = Number(data.submitted_at); // parse string
    data = omit(data, "temp-input");

    createInterest({ variables: { listId: interestListId, data } })
      .then(() => {
        if (submitBtnIndex === 1) return onResetState();

        navigate(`/dash/manager/lists/${interestListId}`);
        return null;
      })
      .catch((err) => {
        logger.sendError(err);
        alert("There was a problem creating the application. Please try again later.");
      });
  };

  const formSchema = get(query, ["data", "applicationFormMetadata", "schema"], []);
  return (
    <div style={styles.container} className="legacy-bs-override">
      <FormRow>
        <Column width={2} />
        <Column width={8}>
          <div className="card" style={styles.tableContainer}>
            <h3 style={styles.header}>{!interestListQuery.loading && (
              <span>{interestListQuery.data?.interestList.name} Application</span>
            )}</h3>
            {!isFormReady && (
              <div style={styles.topPadding}>
                <div>
                  <Grid container spacing={2}>
                    <Grid item md={3}>
                      <KeyboardDatePicker
                        inputVariant="outlined"
                        value={date}
                        disableFuture
                        onChange={handleDateChange}
                        label="Application Date"
                        format="MM/dd/yyyy"
                      />
                    </Grid>
                    <Grid item md={3}>
                      <KeyboardTimePicker
                        inputVariant="outlined"
                        value={time}
                        onChange={handleTimeChange}
                        label="Application Time"
                        format="hh:mm a"
                        error={timeError}
                        helperText={timeError && "Time cannot be in the future."}
                      />
                    </Grid>
                  </Grid>
                </div>

                <FormControl variant="outlined" style={{ minWidth: 150, marginTop: 16, marginBottom: 16 }}>
                  <InputLabel id="household-size-label">Household size</InputLabel>
                  <Select
                    labelId="household-size-label"
                    id="household-size"
                    value={householdCount}
                    onChange={handleSelect}
                    label="Household size"
                    data-testid="household-size-select"
                  >
                    <MenuItem value={0} disabled>Choose</MenuItem>
                    {[...Array(12).keys()].map((idx: number) => (
                      <MenuItem key={`hh-member-${idx}`} value={idx + 1}>{idx + 1}</MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <br />
                <Button
                  type="button"
                  color="secondary"
                  size="L"
                  marginRight
                  onClick={() => history.back()}
                  data-testid="cancel-button"
                >
                  Cancel
                </Button>
                <Button
                  color="primary"
                  size="L"
                  disabled={householdCount === 0 || timeError || !dateTime}
                  onClick={() => setIsFormReady(true)}
                  data-testid="next-button"
                >
                  Next
                </Button>
              </div>
            )}

            {isFormReady && (
              <form onSubmit={handleSubmit} style={{ display: "grid" }}>
                <NewForm
                  formData={{
                    household_count: householdCount,
                    create_type: "paper",
                    submitted_at: dateTime.unix(),
                    is_complete: true,
                    manually_entered: true,
                    contact_method_phone: true,
                    contact_method_sms: true,
                    contact_method_email: true,
                    contact_method_mail: true,
                  }}
                  validationSchema={formSchema}
                />
                <div className="clearfix">
                  <div className="pull-right">
                    <Button
                      type="button"
                      color="secondary"
                      size="L"
                      marginRight
                      onClick={handleCancel}
                      data-testid="cancel-button"
                    >
                      Cancel
                    </Button>

                    <DropDownButton
                      type="submit"
                      size="L"
                      color="primary"
                      disabled={mutation.loading}
                      currentOption={submitBtnIndex}
                      onOptionClick={(index) => setSubmitBtnIndex(index)}
                      options={["Submit & Close", "Submit & New"]}
                    />
                  </div>
                </div>
              </form>
            )}
          </div>
        </Column>
        <Column width={2} />
      </FormRow>
    </div>
  );
};

export default NewInterest;
